"use client";
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    Meter: function() {
        return Meter;
    },
    default: function() {
        return _default;
    }
});
const _jsxruntime = require("react/jsx-runtime");
const _utils = require("@mui/material/utils");
const Meter = (0, _utils.createSvgIcon)(/*#__PURE__*/ (0, _jsxruntime.jsxs)("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
        /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
            d: "M15.2859 10.8703L13.0594 14.4094C12.9683 14.5356 12.8575 14.6464 12.7313 14.7375C12.4265 14.9501 12.0501 15.034 11.6839 14.9708C11.3177 14.9077 10.9912 14.7027 10.7752 14.4003C10.5592 14.0979 10.4712 13.7225 10.5302 13.3557C10.5893 12.9888 10.7907 12.66 11.0906 12.4406L14.6297 10.2141C14.7101 10.158 14.8058 10.1279 14.9039 10.1279C15.002 10.1279 15.0977 10.158 15.1781 10.2141C15.2792 10.287 15.3472 10.397 15.3674 10.52C15.3876 10.6429 15.3583 10.7689 15.2859 10.8703Z",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
            d: "M12 3C6.20156 3 1.5 7.69687 1.5 13.4953C1.49644 16.0607 2.43564 18.538 4.13906 20.4562C4.19062 20.5125 4.2375 20.5687 4.28906 20.6203C4.39999 20.7404 4.53464 20.8361 4.6845 20.9015C4.83435 20.9668 4.99614 21.0003 5.15962 20.9999C5.3231 20.9995 5.48471 20.9651 5.63421 20.8989C5.78371 20.8328 5.91785 20.7363 6.02812 20.6156C6.7882 19.7896 7.71138 19.1303 8.73929 18.6793C9.7672 18.2282 10.8775 17.9954 12 17.9954C13.1225 17.9954 14.2328 18.2282 15.2607 18.6793C16.2886 19.1303 17.2118 19.7896 17.9719 20.6156C18.0821 20.7363 18.2163 20.8328 18.3658 20.8989C18.5153 20.9651 18.6769 20.9995 18.8404 20.9999C19.0039 21.0003 19.1656 20.9668 19.3155 20.9015C19.4654 20.8361 19.6 20.7404 19.7109 20.6203L19.8609 20.4562C21.5644 18.538 22.5036 16.0607 22.5 13.4953C22.5 7.69687 17.7984 3 12 3Z",
            stroke: "currentColor",
            "stroke-width": "1.5",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
        }),
        /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
            d: "M12 6V7.5M19.5 13.5H18M6 13.5H4.5M7.75734 9.25734L6.69656 8.19656M16.2427 9.25734L17.3034 8.19656",
            stroke: "currentColor",
            "stroke-width": "1.5",
            "stroke-miterlimit": "10",
            "stroke-linecap": "round"
        })
    ]
}), "Meter");
const _default = Meter;
